<template>
  <el-dialog
    title="编辑题目"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @closed="dialogClosed"
    width="95%"
    top="20px"
  >
    <div
      style="overflow-y: auto; padding: 0px 30px 0px 10px"
      :style="formBodyStyle"
    >
      <el-form
        :model="elementItem"
        :rules="questionFormRules"
        ref="elementItem"
        label-width="110px"
        class="demo-ruleForm"
        size="mini"
        :label-position="is_xs ? 'top' : 'right'"
      >
        <el-form-item label="题目类型：" prop="QuestionType">
          <span v-if="elementItem.QuestionType === 1">单选</span>
          <span v-if="elementItem.QuestionType === 2">多选</span>
          <span v-if="elementItem.QuestionType === 3">判断</span>
          <span v-if="elementItem.QuestionType === 4">填空</span>
          <span v-if="elementItem.QuestionType === 5">问答</span>
          <span v-if="elementItem.QuestionType === 6">附件</span>
        </el-form-item>
        <el-form-item label="题干：" prop="QuestionStem">
          <VueUeditorWrap
            @ready="ready"
            ref="questionStemEditor"
            v-model="elementItem.QuestionStem"
            :config="ueditorConfig"
          ></VueUeditorWrap>
          <div style="margin: 5px 0px 0px 0px">
            <el-button
              type="primary"
              v-if="elementItem.QuestionType === 4"
              @click="editorInsertText"
            >
              插入填空符
            </el-button>
            <el-button
              v-if="elementItem.QuestionType === 4"
              @click="openSetAttribute"
            >
              填空属性
            </el-button>
          </div>
          <el-dialog
            top="20px"
            title="填空属性"
            :visible.sync="blankDialogVisible"
            :close-on-click-modal="false"
            append-to-body
            custom-class="custom_dialog"
          >
            <div style="overflow-y: auto; padding: 0px" :style="formBodyStyle">
              <div
                style="
                  display: -webkit-flex;
                  display: flex;
                  flex-wrap: nowrap;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: flex-start;
                "
              >
                <div
                  style="
                    font-size: 18px;
                    font-weight: 600;
                    padding: 10px;
                    flex-shrink: 0;
                  "
                >
                  当前题目：
                </div>
                <div v-html="elementItem.QuestionStem"></div>
              </div>
              <el-table
                border
                :data="blankItems"
                style="width: 100%"
                empty-text="暂无填空项"
                v-loading="blankItemsLoading"
              >
                <el-table-column
                  type="index"
                  label="填空"
                  width="60"
                  :index="blankIndexMethod"
                  class-name="blank_cell_vertical_align"
                >
                </el-table-column>
                <el-table-column
                  label="答案"
                  header-align="center"
                  align="left"
                  class-name="blank_cell_vertical_align"
                >
                  <template slot-scope="scope">
                    <!-- <el-input
                      size="mini"
                      placeholder="请输入答案"
                      v-model="scope.row.Content"
                      :key="scope.$index + 'Content'"
                    >
                    </el-input> -->
                    <div>
                      <div
                        class="blank_answer_item"
                        v-for="(contentItem, contentIndex) in scope.row
                          .RightAnswers"
                        :key="contentIndex"
                      >
                        <span class="blank_answer_item_join">
                          {{ contentIndex === 0 ? '' : '或' }}
                        </span>
                        <el-input
                          size="mini"
                          placeholder="请输入答案"
                          v-model="contentItem.Answer"
                          :key="scope.$index + contentIndex + 'Content'"
                          @input="answerInput(scope.$index, scope.row)"
                        >
                        </el-input>
                        <el-link
                          title="删除"
                          class="blank_answer_item_delete"
                          icon="el-icon-close"
                          :underline="false"
                          @click="
                            deleteRightAnswerItem(
                              scope.$index,
                              scope.row,
                              contentIndex
                            )
                          "
                        ></el-link>
                      </div>
                      <div>
                        <el-link
                          type="primary"
                          icon="el-icon-circle-plus-outline"
                          @click="addRightAnswerItem(scope.$index, scope.row)"
                        >
                          添加答案
                        </el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="范围"
                  width="200"
                  align="center"
                  class-name="blank_cell_vertical_align"
                >
                  <template slot-scope="scope">
                    <el-input-number
                      v-model="scope.row.MinWordNum"
                      :step="1"
                      :precision="0"
                      :min="0"
                      :max="9999999"
                      :controls="false"
                      style="width: 80px"
                    ></el-input-number>
                    ~
                    <el-input-number
                      v-model="scope.row.MaxWordNum"
                      :step="1"
                      :precision="0"
                      :min="0"
                      :max="9999999"
                      :controls="false"
                      style="width: 80px"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  label="宽度"
                  width="120"
                  align="center"
                  prop="TextWidth"
                  class-name="blank_cell_vertical_align"
                >
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.TextWidth"
                      filterable
                      allow-create
                      default-first-option
                      :key="scope.$index + 'TextWidth'"
                    >
                      <el-option :label="0" :value="0"> </el-option>
                      <el-option :label="50" :value="50"> </el-option>
                      <el-option :label="100" :value="100"> </el-option>
                      <el-option :label="150" :value="150"> </el-option>
                      <el-option :label="200" :value="200"> </el-option>
                      <el-option :label="300" :value="300"> </el-option>
                      <el-option :label="400" :value="400"> </el-option>
                      <el-option :label="500" :value="500"> </el-option>
                      <el-option :label="600" :value="600"> </el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <!-- <el-button @click="blankDialogVisible = false">取 消</el-button> -->
              <el-button type="primary" @click="editBlankAttribute()">
                确 定
              </el-button>
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item
          label="填空项："
          prop="OptionItems"
          v-if="elementItem.QuestionType === 4"
          key="blankOptionItems"
        >
          <div class="table-block">
            <el-table
              :data="elementItem.OptionItems"
              style="width: 100%"
              empty-text="暂无填空"
              v-loading="optionItemsLoading"
            >
              <el-table-column label="填空" width="80">
                <template slot-scope="scope">
                  {{ '填空' + (scope.$index + 1) }}
                </template>
              </el-table-column>
              <el-table-column label="答案" key="Content">
                <template slot-scope="scope">
                  <!-- <div v-html="scope.row.Content"></div> -->
                  <div class="blank_right_answers_tag_box">
                    <div
                      v-for="(contentItem, contentIndex) in scope.row
                        .RightAnswers"
                      :key="contentIndex"
                      class="blank_right_answers_tag_item"
                    >
                      <el-tag effect="plain" v-show="contentItem.Answer">
                        {{ contentItem.Answer }}
                      </el-tag>
                      <span
                        v-if="contentIndex < scope.row.RightAnswers.length - 1"
                      >
                        或
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="文字长度" width="130" align="center">
                <template slot-scope="scope">
                  {{ scope.row.MinWordNum + '~' + scope.row.MaxWordNum }}
                  <span
                    v-if="
                      scope.row.MinWordNum === 0 &&
                      scope.row.MaxWordNum === 99999
                    "
                  >
                    （默认）
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="输入框宽度" width="130" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.TextWidth > 0">
                    {{ scope.row.TextWidth }}
                  </span>
                  <span v-if="scope.row.TextWidth <= 0"> 自适应 </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item
          label="选项："
          prop="OptionItems"
          v-if="
            elementItem.QuestionType === 1 ||
            elementItem.QuestionType === 2 ||
            elementItem.QuestionType === 3
          "
          required
          key="OptionItems"
        >
          <el-dialog
            top="40px"
            :title="optionItemForm.Id == null ? '添加选项' : '编辑选项'"
            :visible.sync="innerVisible"
            :close-on-click-modal="false"
            append-to-body
            custom-class="custom_dialog"
          >
            <div class="dialog_body_box">
              <el-form
                :model="optionItemForm"
                :rules="optionItemFormRules"
                ref="optionItemForm"
                label-width="110px"
                class="demo-ruleForm"
                size="mini"
                :label-position="is_xs ? 'top' : 'right'"
              >
                <el-form-item label="选项内容：" prop="Content">
                  <VueUeditorWrap
                    ref="contentUeditor"
                    v-model="optionItemForm.Content"
                    :config="ueditorConfig"
                  ></VueUeditorWrap>
                </el-form-item>
                <el-form-item label="正确选项：" prop="IsRight">
                  <el-switch v-model="optionItemForm.IsRight"> </el-switch>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="innerVisible = false">取 消</el-button>
              <el-button
                type="primary"
                @click="editOptionItem('optionItemForm')"
              >
                确 定
              </el-button>
            </div>
          </el-dialog>
          <div class="table-block">
            <el-table
              :data="elementItem.OptionItems"
              style="width: 100%"
              empty-text="暂无选项"
              v-loading="optionItemsLoading"
            >
              <el-table-column
                type="index"
                label=""
                width="50"
                :index="optionIndexMethod"
              >
              </el-table-column>
              <el-table-column label="选项内容" key="Content">
                <template slot-scope="scope">
                  <div v-html="scope.row.Content"></div>
                </template>
              </el-table-column>
              <el-table-column label="正确选项" width="100" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.IsRight"
                    :key="scope.row.index + scope.row.IsRight"
                    @change="optionItemRightChange()"
                  >
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-link
                    title="编辑"
                    type="primary"
                    class="cell_link"
                    @click.stop
                    @click="openEditOptionItem(scope.row, 'edit', scope.$index)"
                  >
                    <i class="el-icon-edit"></i>
                  </el-link>
                  <el-link
                    title="该项下添加"
                    type="primary"
                    class="cell_link"
                    @click.stop
                    @click="openEditOptionItem(scope.row, 'add', scope.$index)"
                  >
                    <i class="el-icon-circle-plus-outline"></i>
                  </el-link>
                  <el-link
                    title="删除"
                    type="primary"
                    class="cell_link"
                    @click.stop
                    @click="deleteOptionItem(scope.$index)"
                  >
                    <i class="el-icon-delete"></i>
                  </el-link>
                  <el-link
                    title="上移"
                    type="primary"
                    class="cell_link"
                    @click.stop
                    @click="moveUpOptionItem(scope.row, scope.$index)"
                  >
                    <i class="el-icon-upload2"></i>
                  </el-link>
                  <el-link
                    title="下移"
                    type="primary"
                    class="cell_link"
                    @click.stop
                    @click="moveDownOptionItem(scope.row, scope.$index)"
                  >
                    <i class="el-icon-download"></i>
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-link
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="
                openEditOptionItem(
                  null,
                  'add',
                  elementItem.OptionItems.length - 1
                )
              "
            >
              添加选项
            </el-link>
          </div>
        </el-form-item>
        <el-form-item label="限制范围：" v-if="elementItem.QuestionType === 5">
          <div class="form_item_inline">
            <el-checkbox
              class="form_item_inline_margin"
              v-model="elementItem.IsLimit"
              @change="questionTextLimitChange()"
            >
              限制
            </el-checkbox>
            <el-form-item
              class="el-form-item-internal form_item_inline_margin"
              prop="MinWordNum"
              v-if="elementItem.IsLimit"
            >
              最小字数：
              <el-input-number
                v-model="elementItem.MinWordNum"
                :step="1"
                :precision="0"
                :min="0"
                :max="9999999"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              class="el-form-item-internal"
              prop="MaxWordNum"
              v-if="elementItem.IsLimit"
            >
              最大字数：
              <el-input-number
                v-model="elementItem.MaxWordNum"
                :step="1"
                :precision="0"
                :min="0"
                :max="9999999"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="宽高设置：" v-if="elementItem.QuestionType === 5">
          <div class="form_item_inline">
            <el-form-item
              class="el-form-item-internal form_item_inline_margin"
              prop="TextHeight"
            >
              高度：
              <el-select
                v-model="elementItem.TextHeight"
                filterable
                allow-create
                default-first-option
              >
                <el-option :label="1" :value="1"> </el-option>
                <el-option :label="2" :value="2"> </el-option>
                <el-option :label="3" :value="3"> </el-option>
                <el-option :label="4" :value="4"> </el-option>
                <el-option :label="5" :value="5"> </el-option>
                <el-option :label="10" :value="10"> </el-option>
              </el-select>
              行
            </el-form-item>
            <el-form-item class="el-form-item-internal" prop="TextWidth">
              宽度：
              <el-select
                v-model="elementItem.TextWidth"
                filterable
                allow-create
                default-first-option
              >
                <el-option :label="0" :value="0"> </el-option>
                <el-option :label="50" :value="50"> </el-option>
                <el-option :label="100" :value="100"> </el-option>
                <el-option :label="150" :value="150"> </el-option>
                <el-option :label="200" :value="200"> </el-option>
                <el-option :label="300" :value="300"> </el-option>
                <el-option :label="400" :value="400"> </el-option>
                <el-option :label="500" :value="500"> </el-option>
                <el-option :label="600" :value="600"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="分数：">
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item class="el-form-item-internal" prop="Score">
              <el-input-number
                v-model="elementItem.Score"
                :step="1"
                :precision="2"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="显示顺序：" v-show="false">
          <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
            <el-form-item class="el-form-item-internal" prop="Sort">
              <el-input
                v-model="elementItem.Sort"
                oninput="value=value.replace(/[^\d]/g,'')"
                :max="1000000"
                autocomplete="off"
                placeholder="请输入排序序号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="是否共享：" prop="IsPublic" v-show="false">
          <el-switch v-model="elementItem.IsPublic"> </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="editElementQuestion()">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ueditorConfig from '../../assets/js/ueditorConfig_simple'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'EditElementTitle',
  components: {
    VueUeditorWrap
  },
  data () {
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    const validateOptionItems = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('选项不能为空！'))
      } else {
        if (this.elementItem.QuestionType === 1) {
          let rightNum = 0
          value.forEach(function (item, index) {
            if (item.IsRight) {
              rightNum += 1
            }
          })
          if (rightNum === 0) {
            // callback(new Error('必须有一项正确选项！'))
            callback()
          } else if (rightNum > 1) {
            callback(new Error('只能有一项正确选项！'))
          } else {
            callback()
          }
        } else if (this.elementItem.QuestionType === 3) {
          let rightNum = 0
          value.forEach(function (item, index) {
            if (item.IsRight) {
              rightNum += 1
            }
          })
          if (rightNum === 0) {
            callback(new Error('必须有一项正确选项！'))
          } else if (rightNum > 1) {
            callback(new Error('只能有一项正确选项！'))
          } else {
            callback()
          }
        } else {
          let rightNum = 0
          value.forEach(function (item, index) {
            if (item.IsRight) {
              rightNum += 1
            }
          })
          if (rightNum === 0) {
            // callback(new Error('必须有一项正确选项！'))
            callback()
          } else {
            callback()
          }
        }
      }
    }
    return {
      dialogFormVisible: false,
      formBodyStyle: { maxHeight: (window.innerHeight - 250) + 'px' },
      ueditorConfig: ueditorConfig,
      elementItem: {
        OptionItems: []
      },
      itemIndex: 0,
      action: 'add',
      questionFormRules: {
        QuestionStem: [
          { required: true, message: '请输入题干', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }],
        OptionItems: [
          { validator: validateOptionItems, trigger: 'blur' }],
        MinWordNum: [
          { required: true, message: '请输入最小字数', trigger: 'blur' }],
        MaxWordNum: [
          { required: true, message: '请输入最大字数', trigger: 'blur' }]
      },
      innerVisible: false,
      optionItemForm: {
        Id: null,
        Content: '',
        IsRight: false,
        TextHeight: 1,
        TextWidth: 150,
        MinWordNum: null,
        MaxWordNum: null,
        TextValidation: null
      },
      optionItemFormRules: {
        Content: [
          { required: true, message: '请输入内容', trigger: 'blur' }]
      },
      optionItemAction: 'add',
      optionItemIndex: 0,
      optionItemsLoading: false,
      questionStemEditor: {},
      blankItems: [],
      blankDialogVisible: false,
      blankItemsLoading: false
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    openEditElementQuestion: function (item, index, action) {
      this.openLoading()
      this.dialogFormVisible = true
      this.elementItem = item
      this.itemIndex = index
      this.action = action
      if (!this.elementItem.MinWordNum && !this.elementItem.MaxWordNum) {
        this.$set(this.elementItem, 'IsLimit', false)
      } else {
        this.$set(this.elementItem, 'IsLimit', true)
      }
      if (this.elementItem.QuestionType === 4) {
        this.elementItem.OptionItems.forEach(function (item, index) {
          if (item.Content) {
            item.RightAnswers = JSON.parse(item.Content)
          } else {
            item.RightAnswers = []
          }
        })
      }
      this.openLoading().close()
    },
    editElementQuestion: function () {
      const _this = this
      _this.$refs.elementItem.validate((valid) => {
        if (valid) {
          if (_this.elementItem.QuestionType === 4) {
            _this.getAttribute()
            _this.elementItem.OptionItems = JSON.parse(JSON.stringify(_this.blankItems))
          }
          _this.fatherSubmitDialog(_this.elementItem, _this.itemIndex, _this.action)
          _this.dialogFormVisible = false
        } else {
          return false
        }
      })
    },
    dialogClosed: function (done) {
      this.elementItem = {}
    },
    openEditOptionItem: function (item, action, index) {
      this.innerVisible = true
      this.optionItemsLoading = true
      this.optionItemAction = action
      this.optionItemIndex = index
      if (this.optionItemAction === 'add') {
        this.optionItemForm = {
          Id: null,
          Content: '',
          IsRight: false,
          TextHeight: 1,
          TextWidth: 150,
          MinWordNum: null,
          MaxWordNum: null,
          TextValidation: null
        }
      } else {
        this.optionItemForm = {}
        this.optionItemForm = JSON.parse(JSON.stringify(item))
      }
      this.optionItemsLoading = false
    },
    editOptionItem: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          this.optionItemsLoading = true
          if (_this.optionItemAction === 'add') {
            _this.elementItem.OptionItems.splice(this.optionItemIndex + 1, 0, JSON.parse(JSON.stringify(_this.optionItemForm)))
          } else {
            _this.elementItem.OptionItems.splice(this.optionItemIndex, 1, JSON.parse(JSON.stringify(_this.optionItemForm)))
          }
          _this.innerVisible = false
          this.optionItemsLoading = false
          _this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!',
            customClass: 'custom_message'
          })
          _this.$refs.elementItem.validateField('OptionItems', validError => { })
        } else {
          return false
        }
      })
    },
    deleteOptionItem: function (index) {
      const _this = this
      _this.$confirm('确认删除该选项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box',
        dangerouslyUseHTMLString: true
      }).then(() => {
        _this.optionItemsLoading = true
        _this.elementItem.OptionItems.splice(index, 1)
        _this.optionItemsLoading = false
        _this.$refs.elementItem.validateField('OptionItems', validError => { })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    moveUpOptionItem: function (item, index) {
      const _this = this
      this.optionItemsLoading = true
      if (index > 0) {
        _this.elementItem.OptionItems.splice(index, 1)
        _this.elementItem.OptionItems.splice(index - 1, 0, item)
      }
      this.optionItemsLoading = false
    },
    moveDownOptionItem: function (item, index) {
      const _this = this
      this.optionItemsLoading = true
      if (index < _this.elementItem.OptionItems.length - 1) {
        _this.elementItem.OptionItems.splice(index, 1)
        _this.elementItem.OptionItems.splice(index + 1, 0, item)
      }
      this.optionItemsLoading = false
    },
    optionIndexMethod (index) {
      if (index < 26) {
        return String.fromCharCode(65 + index) + '、'
      } else {
        return index + 1
      }
    },
    optionItemRightChange: function () {
      const _this = this
      _this.$refs.elementItem.validateField('OptionItems', validError => { })
    },
    questionTextLimitChange: function () {
      const _this = this
      if (!_this.elementItem.IsLimit) {
        _this.elementItem.MinWordNum = null
        _this.elementItem.MaxWordNum = null
      }
    },
    ready (instance) {
      const _this = this
      _this.questionStemEditor = instance
    },
    editorInsertText () {
      const _this = this
      _this.questionStemEditor.focus()
      _this.questionStemEditor.execCommand('inserthtml', '___')
    },
    getAttribute: function () {
      const _this = this
      const stemArray = _this.elementItem.QuestionStem.split('___')
      _this.blankItems = []
      stemArray.forEach(function (item, index) {
        if (index < stemArray.length - 1) {
          if (item !== '') {
            _this.blankItems.push({ Content: '', IsRight: true, TextHeight: 1, TextWidth: 150, MinWordNum: 0, MaxWordNum: 99999, TextValidation: null, RightAnswers: [{ Answer: '' }] })
          }
        }
      })
      _this.blankItems.forEach(function (item, index) {
        if (_this.elementItem.OptionItems.length > index) {
          const optionItem = JSON.parse(JSON.stringify(_this.elementItem.OptionItems[index]))
          _this.blankItems[index].Content = optionItem.Content
          if (optionItem.Content) {
            _this.blankItems[index].RightAnswers = JSON.parse(optionItem.Content)
          } else {
            _this.blankItems[index].RightAnswers = [{ Answer: '' }]
          }
          _this.blankItems[index].IsRight = optionItem.IsRight
          _this.blankItems[index].TextHeight = optionItem.TextHeight
          _this.blankItems[index].TextWidth = optionItem.TextWidth
          _this.blankItems[index].MinWordNum = optionItem.MinWordNum
          _this.blankItems[index].MaxWordNum = optionItem.MaxWordNum
          _this.blankItems[index].TextValidation = optionItem.TextValidation
        }
      })
    },
    openSetAttribute: function () {
      const _this = this
      _this.blankItemsLoading = true
      _this.getAttribute()
      _this.blankDialogVisible = true
      _this.blankItemsLoading = false
    },
    blankIndexMethod (index) {
      return '填空' + (index + 1)
    },
    editBlankAttribute: function () {
      const _this = this
      _this.elementItem.OptionItems = JSON.parse(JSON.stringify(_this.blankItems))
      _this.elementItem.OptionItems.forEach(function (item, index) {
        item.Content = JSON.stringify(item.RightAnswers)
      })
      _this.blankDialogVisible = false
      _this.blankItemsLoading = false
    },
    addRightAnswerItem: function (blankItemsIndex, item) {
      const _this = this
      item.RightAnswers.push({ Answer: '' })
      _this.$set(_this.blankItems, blankItemsIndex, item)
    },
    answerInput: function (blankItemsIndex, item) {
      const _this = this
      _this.$set(_this.blankItems, blankItemsIndex, item)
    },
    deleteRightAnswerItem: function (blankItemsIndex, item, deleteIndex) {
      const _this = this
      item.RightAnswers.splice(deleteIndex, 1)
      _this.$set(_this.blankItems, blankItemsIndex, item)
    }
  },
  created () {

  },
  watch: {
    'elementItem.QuestionStem': {
      handler (newValue, oldValue) {
        // console.log(oldValue)
        // console.log(newValue)
        if (oldValue && newValue) {
          if (oldValue.split('___').length !== newValue.split('___').length) {
            this.getAttribute()
            this.elementItem.OptionItems = JSON.parse(JSON.stringify(this.blankItems))
          }
        }
      }
    }
  }
}
</script>
<style lang="less">
.blank_cell_vertical_align {
  vertical-align: top !important;
}
.blank_answer_item {
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0px 0px 5px 0px;
}
.blank_answer_item .blank_answer_item_join {
  width: 26px;
}
.blank_answer_item .blank_answer_item_delete {
  width: 26px;
}
.blank_right_answers_tag_box {
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.blank_right_answers_tag_item {
  padding: 0px 0px 8px 0px;
}
.blank_right_answers_tag_item span {
  padding: 0px 8px;
}
</style>
